import { render } from "./SwdTag.vue?vue&type=template&id=ee0e86c0"
import script from "./SwdTag.vue?vue&type=script&lang=js"
export * from "./SwdTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__